// extracted by mini-css-extract-plugin
export default {"content":"ZHk_x","cardOrImage":"FDkqO","email":"HP7rW","title":"AurQo","description":"E31DH"};